export default "__VITE_ASSET__UxkdwSqV__"